export const onlyEnglishLetters = /^[A-Za-z]+$/;
export const lateinLettersAndAllowedSymbols = /^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ\s\-\/.'"]+$/;
